/* eslint-disable max-len */
import {
  useEffect, useRef, useState,
} from 'react';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import useLoadTriangulation from './functions/useLoadTriangulation';
import useSubmitFile from './functions/useSubmitFile';
import useFilters from './functions/useFilters';

export default function useTriangulation() {
  const [visualizationKind, setVisualizationKind] = useState<'cwp' | 'dwp' | 'employees'>('cwp');
  const [dataView, setDataView] = useState<'map' | 'list'>('map');

  const downloadExampleFileRef = useRef<HTMLAnchorElement | null>(null);

  const { userProfile, companyCode } = useGetGeneralAppData();

  const {
    isLoadLoading,
    rolesList,
    setRolesList,
    sindList,
    setSindsList,
    employeesList,
    setEmployeesList,
    currentWorkplaceList,
    setCurrentWorkplaceList,
    destinyWorkplaceList,
    setDestinyWorkplaceList,
    dataList,
    setDataList,
    apiFetched,
    getTriangulationData,
  } = useLoadTriangulation();

  const {
    isSubmitting,
    isModalVisible,
    setIsModalVisible,
    csvFileName,
    setCsvParsed,
    handleFileUpload,
    handleSubmitFile,
    setCsvFileName,
  } = useSubmitFile({ getTriangulationData });

  const {
    isRolesSelectDisabled,
    selectedEmployee,
    selectedCurrentWorkplace,
    selectedDestinyWorkplace,
    dataByCurrentWorkplace,
    dataByDestinyWorkplace,
    dataByEmployee,
    rawData,
    handleRoleChange,
    handleSindChange,
    handleCurrentWorkplaceChange,
    handleDestinyWorkplaceChange,
    handleEmployeeChange,
    selectedRole,
    selectedSind,
    setSelectedDestinyWorkplace,
    setSelectedEmployee,
    setSelectedCurrentWorkplace,
    isFiltering,
    resetFields,
  } = useFilters({
    setSindsList,
    setEmployeesList,
    setCurrentWorkplaceList,
    setDestinyWorkplaceList,
    dataList,
    getTriangulationData,
    setVisualizationKind,
    setCsvFileName,
    setCsvParsed,
    setDataView,
    setRolesList,
    setDataList,
  });

  const isLoading = isLoadLoading || isFiltering || isSubmitting;

  useEffect(() => { resetFields(true); }, [resetFields]);

  return ({
    isLoading,
    visualizationKind,
    isModalVisible,
    rolesList,
    isRolesSelectDisabled,
    sindList,
    employeesList,
    selectedEmployee,
    currentWorkplaceList,
    selectedCurrentWorkplace,
    destinyWorkplaceList,
    selectedDestinyWorkplace,
    apiFetched,
    csvFileName,
    dataByCurrentWorkplace,
    dataByDestinyWorkplace,
    dataByEmployee,
    rawData,
    dataView,
    downloadExampleFileRef,
    handleFileUpload,
    handleSubmitFile,
    handleRoleChange,
    handleSindChange,
    handleCurrentWorkplaceChange,
    handleDestinyWorkplaceChange,
    handleEmployeeChange,
    userProfile,
    companyCode,
    dataList,
    selectedRole,
    selectedSind,
    setIsModalVisible,
    setVisualizationKind,
    setSelectedDestinyWorkplace,
    setSelectedEmployee,
    setDataView,
    setSelectedCurrentWorkplace,
    getTriangulationData,
  });
}
